import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import DefaultInput from '../../../shared/default-input/components/default-input';
import DefaultTextarea from '../../../shared/default-textarea/components/default-textarea';
import DefaultSelect from '../../../shared/default-select/components/default-select';
import Button from '../../../shared/button/components/button';
import withdrawalConstants from '../constants/withdrawal-constants';
import { validate } from '../validators/withdrawal-validators';
import { requestWithdrawal, getRate } from '../actions/withdrawal-actions';

import '../styles/withdrawal-form.css';

class WithdrawalForm extends Component {
  handleFormChange(e, changedField) {
    const { getRate, formValues } = this.props;

    const amount = changedField === withdrawalConstants.fields.amount ? e.target.value : formValues.amount;
    const currency = changedField === withdrawalConstants.fields.currency ? e.target.value : formValues.currency;

    if (!amount || currency === withdrawalConstants.withdrawal_currencies.usd.value) {
      return;
    }

    getRate();
  }

  getWithdrawalAmount() {
    const { rate, formValues } = this.props;

    if (!formValues || !formValues.amount || !formValues.currency || (formValues.currency === withdrawalConstants.withdrawal_currencies.eur.value && !rate)) {
      return '';
    }

    if (formValues.currency === withdrawalConstants.withdrawal_currencies.usd.value) {
      return `${withdrawalConstants.withdrawal_currencies.usd.symbol}${formValues.amount}`;
    }

    return `${withdrawalConstants.withdrawal_currencies.eur.symbol}${parseFloat(formValues.amount / rate).toFixed(2)}`;
  }

  handleFormSubmit(values) {
    const { requestWithdrawal } = this.props;

    requestWithdrawal(
      values[withdrawalConstants.fields.amount],
      values[withdrawalConstants.fields.description],
      values[withdrawalConstants.fields.payment_method_id],
      values[withdrawalConstants.fields.currency]
    );
  }

  render() {
    const { handleSubmit, httpInProgress, getRateInProgress, paymentMethods } = this.props;
    const currencies = _.values(withdrawalConstants.withdrawal_currencies);
    const buttonLabelTranslations = {
      amount: this.getWithdrawalAmount(),
    };

    return (
      <div className="withdrawal-form-container">
        <form onSubmit={handleSubmit(values => this.handleFormSubmit(values))} noValidate className="withdrawal-form-container__form-wrapper">
          <div className="row">
            <div className="col-md-12 m-b-20">
              <Field
                name={withdrawalConstants.fields.payment_method_id}
                inputName={withdrawalConstants.fields.payment_method_id}
                label={'WITHDRAWAL.PAYMENT_METHOD'}
                options={paymentMethods}
                optionLabel={'custom_name'}
                optionValue={'payment_method_id'}
                component={DefaultSelect}
              />
            </div>
            <div className="col-md-12 m-b-20">
              <Field
                name={withdrawalConstants.fields.currency}
                inputName={withdrawalConstants.fields.currency}
                label={'REGISTER.CURRENCY'}
                options={currencies}
                optionLabel={'text'}
                optionValue={'value'}
                component={DefaultSelect}
                onChange={e => this.handleFormChange(e, withdrawalConstants.fields.currency)}
              />
            </div>
            <div className="col-md-12 m-b-20">
              <Field
                name={withdrawalConstants.fields.amount}
                label={'WITHDRAWALS.AMOUNT_LABEL'}
                disabled={httpInProgress}
                onChange={e => this.handleFormChange(e, withdrawalConstants.fields.amount)}
                component={DefaultInput}
                errorTranslationValues={{
                  amount: withdrawalConstants.min_withdrawal_amount
                }}
                type="number"
              />
            </div>
            <div className="col-md-12 m-b-20">
              <Field name={withdrawalConstants.fields.description} label={'WITHDRAWALS.COMMENT_LABEL'} disabled={httpInProgress} component={DefaultTextarea} />
            </div>
          </div>
          <Button
            label={'WITHDRAWALS.SUBMIT_BTN'}
            translationVariables={buttonLabelTranslations}
            customClass={'affiliate-btn-red m-t-20'}
            disabled={httpInProgress || getRateInProgress}
            type={'submit'}
          />
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  userBalance: state.paymentsReducer.userBalance,
  paymentMethods: state.paymentMethodsReducer.paymentMethods,
  getRateInProgress: state.withdrawalReducer.getRateInProgress,
  rate: state.withdrawalReducer.rate,
  profile: state.userProfileReducer.profile,
  formValues: getFormValues(withdrawalConstants.form_name)(state),
  initialValues: {
    currency: withdrawalConstants.withdrawal_currencies.usd.value,
  },
});

const mapDispatchToProps = dispatch => ({
  requestWithdrawal: (amount, comment, paymentMethodId, currency) => {
    dispatch(requestWithdrawal(amount, comment, paymentMethodId, currency));
  },
  getRate: symbol => {
    dispatch(getRate(symbol));
  },
});

WithdrawalForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

WithdrawalForm = reduxForm({
  form: withdrawalConstants.form_name,
  validate,
})(WithdrawalForm);

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawalForm);



// WEBPACK FOOTER //
// ./src/app/main/withdrawals/components/withdrawal-form.js